"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Primary = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _buttonIcon = _interopRequireDefault(require("../components/button/button-icon"));
var _checkbox = _interopRequireDefault(require("../components/checkbox/checkbox"));
var _menu = _interopRequireDefault(require("../components/menu/menu"));
var _outline = _interopRequireDefault(require("../components/pagination/outline"));
var _popconfirm = _interopRequireDefault(require("../components/popconfirm/popconfirm"));
var _button = _interopRequireDefault(require("../components/radio/button"));
var _radio = _interopRequireDefault(require("../components/radio/radio"));
var _selectTag = _interopRequireDefault(require("../components/select/selectTag"));
var _steps = _interopRequireDefault(require("../components/steps/steps"));
var _switch = _interopRequireDefault(require("../components/switch/switch"));
var _table = _interopRequireDefault(require("../components/table/table"));
var _tabs = _interopRequireDefault(require("../components/tabs/tabs"));
var _timeline = _interopRequireDefault(require("../components/timeline/timeline"));
var Primary = exports.Primary = function Primary(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    size: 'small',
    id: id
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: 'vertical'
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    align: 'start',
    size: 'large'
  }, _menu.default.demo, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: 'vertical',
    size: 'large'
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: 'large',
    align: 'start'
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: 'vertical',
    size: 'large'
  }, /*#__PURE__*/_react.default.createElement("div", null, _buttonIcon.default.demo), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, _radio.default.demo), _checkbox.default.demo, _switch.default.demo), /*#__PURE__*/_react.default.createElement("div", null, _button.default.demo), _tabs.default.demo), _selectTag.default.demo), _outline.default.demo, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 12
    }
  }, _steps.default.demo), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: 'large',
    align: 'start'
  }, _popconfirm.default.demo, _timeline.default.demo))), _table.default.demo));
};